import WINDOW from "../../../../utils/window";
import getCenter from "./get-center";

/**
 *
 * @param {MainClassProps} main
 * @param {TriggerProps} trigger
 * @returns
 */
const getPointerFacing = (main, trigger) => {
  const bounds = /** @type {BoundsProps} */ (main.bounds);
  const center = getCenter(bounds);
  const centerX = /** @type {Number} */ (center.get("x"));
  const centerY = /** @type {Number} */ (center.get("y"));

  const pointer = /** @type {Map<"x" | "y", Number>} */ (WINDOW.get("pointer"));
  const pointerX = /** @type {Number} */ (pointer.get("x"));
  const pointerY = /** @type {Number} */ (pointer.get("y"));

  const pointX = centerX - pointerX;
  const pointY = centerY - pointerY;
  const angle = Math.atan2(pointX, -pointY) * (180 / Math.PI);
  const both = angle / 360;

  return both;
};

export default getPointerFacing;
